<template>
  <base-layout>
  <template v-slot:header>
    <app-header/>
  </template>
  <template v-slot:banner>
    <section class="banner_area">
      <div class="banner_inner d-flex align-items-center">
        <div class="container">
          <div
            class="banner_content d-md-flex justify-content-between align-items-center"
          >
            <div class="mb-3 mb-md-0">
              <h2>{{product.name}}</h2>
              <!-- <p>{{product.name}}</p> -->
            </div>
            <div class="page_link">
              <a href="/">Home</a>
              <a :href="`/products/${product.slug}`">Product Details</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  <template v-slot:default>
   <Details :product="product"/>
  </template>

  <template v-slot:footer>
   <app-footer/>
  </template>
</base-layout>
</template>

<script>
/* eslint-disable standard/object-curly-even-spacing */
import productList from '../config/products.json'
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Details from '@/components/ProductDetails'
import BaseLayout from '@/layout/BaseLayout'
export default {
  title () {
    if (this.product) {
      return `${this.product.name} - SanitizerWristbands.com`
    }
    return 'SanitizerWristbands.com'
  },
  components: {
    AppHeader,
    AppFooter,
    Details,
    BaseLayout
  },
  data () {
    return {
      product: null
    }
  },
  mounted () {
    window.analytics.page('Product')
  },
  created () {
    const slug = this.$route.params.slug
    const product = productList.filter(x => x.slug === slug)
    this.product = product[0]
    window.gtag('event', 'view_item', {
      'items': [this.product]
    })
  },
  metaInfo () {
    return {
      title: `SanitizerWristbands.com: ${this.product.name} (${this.product.color})`,
      meta: [
        { name: 'description', content: `Buy ${this.product.name} (${this.product.color}) on SanitizerWristbands.com`},
        { property: 'og:title', content: `SanitizerWristbands.com: ${this.product.name} (${this.product.color})`},
        { property: 'og:site_name', content: 'SanitizerWristbands'},
        { property: 'og:description', content: `Buy ${this.product.name} (${this.product.color}) on SanitizerWristbands.com`},
        { property: 'og:type', content: 'og:product'},
        { property: 'og:url', content: `https://sanitizerwristbands.com/products/${this.product.slug}`},
        { property: 'og:image', content: this.product.image_url },
        { property: 'product:price:amount', content: this.product.price },
        { property: 'product:price:currency', content: 'USD' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/SingleProduct.vue